module.exports = __webpack_public_path__ + "media/apps/hero-illustration-1bb7e3e2.jpg";